@use '@design/design-tokens/typography/typography' as *;

@keyframes iconShrink {
  from {
    height: 48px;
    width: 48px;
  }

  to {
    height: 20px;
    width: 20px;
  }
}

@keyframes iconExpand {
  from {
    height: 20px;
    width: 20px;
  }

  to {
    height: 48px;
    width: 48px;
  }
}

.flexRow {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  gap: 8px;
}

.logoAndTitle {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;

  > :first-child {
    animation: iconExpand 0.2s ease-out;
  }

  &.condensed > :first-child {
    animation: iconShrink 0.2s ease-out;
  }
}

.titleRow {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.rightCluster {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-left: auto;
}

.titleText {
  @include typography-v2-body-md;
  text-transform: capitalize;
}

.themeType{
  @include typography-v2-title-sm;
}

.nameAndReturn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  min-width: 0;
}

.returnRow {
  display: flex;
  gap: 8px;
  align-items: center;
}

.returnValue {
  font-family: var(--font-roboto-mono);
  font-size: 16px;
  line-height: 24px;

  &.bullish {
    color: var(--viz-bullish);
  }

  &.bearish {
    color: var(--viz-bearish);
  }

  &.neutral {
    color: var(--text-default);
  }

  &.condensed {
    @include typography-v2-body-sm;
    font-family: var(--font-roboto-mono);
  }
}

.returnLabel {
  @include typography-v2-body-xs;
  color: var(--text-soft);
  padding-top: 6px;
  padding-bottom: 2px;
}
